(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-index.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-index.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class Index extends svs.tur.Base {
  constructor(_ref) {
    let {
      row,
      index
    } = _ref;
    super({
      className: 'ball-row-index'
    });
    this.row = row;
    this.index = index;
    this.$el.innerText = index;
    this.row.$inner.appendChild(this.$el);
  }
  render() {
    return this.$el;
  }
}
svs.tur.ball.row.extensions.Index = Index;

 })(window);